import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { SuccessAutoDismissFlag } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import { useIntl } from '@atlassian/jira-intl';
import flagMessages from './messages.tsx';
import type { Props } from './types.tsx';

const CardCreateUnmappedFlagInIpBoard = ({
	onDismissed,
	id,
	onClearAllButtonClicked,
	cardTypeName,
}: Props) => {
	const { formatMessage } = useIntl();

	const getTitle = () => {
		if (expVal('jira-itr-work-type-exp-1', 'isEnabled', false)) {
			return flagMessages.updatedIssueHiddenTitleIssueTerminologyRefreshM4;
		}
		if (expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
			return flagMessages.updatedIssueHiddenTitleIssueTermRefresh;
		}
		return flagMessages.updatedIssueHiddenTitleIssueTermRefresh;
	};

	return (
		<SuccessAutoDismissFlag
			id={id}
			onDismissed={onDismissed}
			title={formatMessage(getTitle(), { workType: cardTypeName || '' })}
			description={formatMessage(flagMessages.updatedIssueHiddenDescription)}
			actions={[
				{
					content: formatMessage(flagMessages.clearFiltersActionText),
					onClick: () => {
						onClearAllButtonClicked();
						onDismissed && onDismissed(id);
					},
				},
			]}
		/>
	);
};

export default CardCreateUnmappedFlagInIpBoard;
